import styled from 'styled-components'
import { ScoreTop } from '../../../models/ScoreTop'

type GraphBarParam = {
  score: ScoreTop
  backColor?: string
  foreCore?: string
  maxScore?: number
  height?: number
}

function GraphBar(props: GraphBarParam) {
  return (
    <ScoreBackground>
      {props.score && (
        <div>
          <div
            style={{
              backgroundColor: props.backColor || '#5959ef',
              color: props.foreCore || 'white',
              width: `${props.score.score}%`,
              height: props.height ? `${props.height}px` : 'auto',
            }}
          >
            {/* width:
            props.maxScore === 100
              ? `${props.score.score}%`
              : `${(props.score.score / props.maxScore!) * 100}%`, */}

            <div>{props.score.scoreCode.name}</div>
            <div>{props.score.score}</div>
          </div>
        </div>
      )}
    </ScoreBackground>
  )
}

const ScoreBackground = styled.div`
  text-align: center;
  margin-bottom: 4px;

  & > div {
    background-color: #e4e4e4;
  }
  & > div > div {
    box-sizing: border-box;
    padding: 10px;
    display: flex;
    justify-content: space-between;
  }
`

export default GraphBar
